export default function CouncilRelatedEntries() {
  return (
    <table id="filetable">
      {/*Start Table*/}
      <tr>
        <th>File Name</th>
        <th>Date Posted</th>
      </tr>
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/council/related/Stockham-Building-2025-01-14-Structural-Condition-Assessment-Report-Final.pdf" target="_blank" rel="noopener noreferrer">
            Ramtin Group Structural Condition Assessment Report Dated 1/14/25
          </a>
        </td>
        <td>04/24/2026</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/council/related/Stockham-Building-2025-05-01-GA-Memo.pdf" target="_blank" rel="noopener noreferrer">
            Gilmore &amp; Associates Memo Dated 5/1/25
          </a>
        </td>
        <td>04/24/2026</td>
      </tr>
      {/*End File*/}
      {/*Start File*/}
      <tr>
        <td>
          <a href="../docs/council/related/Stockham-Building-Treacy-Brothers-Final-Estimate.pdf" target="_blank" rel="noopener noreferrer">
            Treacy Brothers Final Estimate
          </a>
        </td>
        <td>04/24/2026</td>
      </tr>
      {/*End File*/}
    </table>
  );
}
